angular.module('tf.controllers')
    .controller('AccountUserSettingsController', ['$scope', 'Session','$uibModal','HttpService','ConfirmExitService', 'NotificationService',
        function ($scope, Session, $uibModal, HttpService, ConfirmExitService, NotificationService) {

            $scope.user = angular.copy(Session.user);

            $scope.timezones = moment.tz.names();
            $scope.isWorking=false;
            var isDeleted = false;

            var unwatch;

            $scope.updateUser = function(){
                $scope.isWorking=true;
                HttpService.post('user/me', {user : $scope.user}).then(function(res){
                    $scope.isWorking=false;
                    Session.updateUser(res.data);
                    window.onbeforeunload = null;
                    $scope.settingsChanged = false;

                    monitorChanges();
                });
            };


            var monitorChanges = function(){
                unwatch =  $scope.$watch('user', function(newVal, oldVal){
                    if(newVal && oldVal && !_.isEqual(newVal, oldVal)){
                        unwatch();
                        $scope.settingsChanged = true;
                        if(!window.onbeforeunload) {
                            window.onbeforeunload = ConfirmExitService.onBeforeUnload("Are you sure you want to leave this page?");
                        }
                    }
                }, true);
            };

            monitorChanges();

            $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
                if(window.onbeforeunload && $scope.settingsChanged && isDeleted) {
                    event.preventDefault();
                    ConfirmExitService.popup(toState, toParams, 'You have unsaved changes', 'Are you sure you want to leave?');
                }
            });


            $scope.changePasswordPopup= function(cb) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'js/components/changePassword/change-password.html',
                    controller: function($scope, HttpService, NotificationService, $timeout){
                        $scope.credentials = {};


                        setTimeout(function(){$('.modal input').first().focus();},1);

                        $scope.changePass = function(){
                            $scope.isWorking = true;
                            HttpService.post('user/me/password', $scope.credentials).then(function(){
                                $scope.$close(true);
                            });
                        };
                        var unwatch = $scope.$watch('credentials', function(newVal, oldVal){
                            if(newVal && oldVal && !_.isEqual(newVal, oldVal)){
                                unwatch();
                                $scope.settingsChanged = true;
                            }
                        }, true);

                        $scope.cancel = function(){
                            if($scope.settingsChanged) {
                                event.preventDefault();
                                NotificationService.popup('confirm-settings-exit', {
                                    onLeave: function(){
                                        $timeout(function(){$scope.$close();},200);
                                    }
                                },{backdrop : false});
                            } else {
                                $scope.$close();
                            }
                        };
                    },
                    size: 'md',
                    windowTopClass : 'change-password-modal',
                    backdrop : 'static'
                });
                modalInstance.result.then(function(success){
                    if(success && cb){
                        cb();
                    }
                });
            };

            $scope.deleteAccount= function(cb) {
                if(!Session.user.isFarmOwner()) {
                    var modalInstance = $uibModal.open({
                        animation: true,
                        templateUrl: 'js/components/deleteAccount/delete-account.html',
                        controller: function ($scope, HttpService) {
                            $scope.credentials = {};
                            $scope.errorMessage = '';


                            setTimeout(function () {
                                $('.modal input').first().focus();
                            }, 1);

                            $scope.deleteAccount = function () {
                                $scope.isWorking = true;
                                $scope.errorMessage = '';
                                HttpService.post('user/me/delete', $scope.credentials).then(function (res) {
                                    window.onbeforeunload = undefined;
                                    isDeleted = true;
                                    $scope.$close();
                                }, function (err) {
                                    $scope.errorMessage = err.data;
                                    isDeleted = false;
                                    $scope.isWorking = false;
                                });
                            };
                            var unwatch = $scope.$watch('credentials', function (newVal, oldVal) {
                                if (newVal && oldVal && !_.isEqual(newVal, oldVal)) {
                                    unwatch();
                                    $scope.settingsChanged = true;
                                }
                            }, true);

                            $scope.cancel = function () {
                                $scope.$close();
                            };
                        },
                        size: 'md',
                        windowTopClass: 'delete-account-modal',
                        backdrop: 'static'
                    });
                    modalInstance.result.then(function (success) {
                        if (success && cb) {
                            cb();
                        }
                    });
                }else{
                    var popupInfo = '<b>In order to delete your user please</b>' +
                        '<br/><a href=\"mailto:admin@templatefarm.io\">Contact Us  </a>';
                    NotificationService.popup('info-popup', {
                        content : popupInfo
                    });
                }
            };
        }]);